module.exports = __webpack_public_path__ + "img/7.12d44f59.jpg";